import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LanguageService } from '../language.service';
import { msgAppAccessService } from '../msgappaccess.service';
import { LoginService } from '../login.service';

MAT_DIALOG_DATA
@Component({
    selector: 'app-messaging-app-dialog',
    templateUrl: './messaging-app-dialog.component.html',
    styleUrls: ['./messaging-app-dialog.component.scss'],
    standalone: false
})
export class MessagingAppDialogComponent implements OnInit {
  safeUrl: SafeResourceUrl;
  

  constructor(
    private sanitizer: DomSanitizer,
    public lang: LanguageService,
    public loginService: LoginService,
    public dialogRef: MatDialogRef<MessagingAppDialogComponent>,
    public msgAppAccessService: msgAppAccessService, 
    @Inject(MAT_DIALOG_DATA) public data:any

  ) { }

  ngOnInit(): void {
    const baseUrl = 'https://msg.artisansonics.com';
    const url = new URL(baseUrl);

    if (this.loginService.location) {
      url.searchParams.append('location', this.loginService.location);
    }

    if (this.loginService.officeServer) {
      url.searchParams.append('office_server', 'true');
    }

    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
  }

  closeDialog() {
    this.dialogRef.close();
  }
  minimizeDialog(): void {
    this.msgAppAccessService.minimize();
  }
}
